export const ISIN_MATCHED_DP = 481000011;
export const LEI_MATCHED_DP = 481000012;
export const CUSIP_MATCHED_DP = 481000023;
export const SEDOL_MATCHED_DP = 481000024;
export const WEBSITE_MATCHED_DP = 481000032;

export const ISIN_ACCESSOR = 'ISINs - Matched';
export const LEI_ACCESSOR = 'LEIs - Matched';
export const CUSIP_ACCESSOR = 'CUSIP - Matched';
export const SEDOL_ACCESSOR = 'SEDOL - Matched';
export const WEBSITE_ACCESSOR = 'Websites - Matched';
